import { inject, Injectable } from '@angular/core';
import { ICartDataProvider } from '../../../models/util/cartDataProvider';
import { Cart } from '../../../models/cart';
import { DbService } from '../../db/db.service';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../auth/auth.service';
import { Product } from '../../../models/product';
import firebase from "firebase/compat/app";
import { isNullOrUndefined } from '@pineapplelab/util';

@Injectable({
	providedIn: 'root'
})
export class LoggedCartProviderService implements ICartDataProvider {

	private readonly dbService = inject(DbService);
	private readonly authService = inject(AuthService);

	user = this.authService.auth.user;

	private getUserDocumentRef(userId?: string): firebase.firestore.DocumentReference<firebase.firestore.DocumentData> {
		if (isNullOrUndefined(userId)) {
			userId = this.user?.id
		}
		return this.dbService
			.getProyIdRef(environment.projectId)
			.collection(Cart.PATH)
			.doc(userId);
	}

	async get(): Promise<Cart> {
		const cartSnapshot = await this.getUserDocumentRef().get();

		if (!cartSnapshot.exists) {
			return null;
		}
		const cart = new Cart(cartSnapshot.data());
		cart.items = cart.items.map(item => new Product(item));
		return cart;
	}

	async save(cart: Cart, userId?: string): Promise<void> {
		if (!cart?.createdAt) {
			cart.createdAt = firebase.firestore.Timestamp.now();
		}
		if (!cart?.id) {
			cart.id = userId ?? this.user?.id;
		}
		const json = cart.toJson();
		await this.getUserDocumentRef(userId).set(json, { merge: true });
	}

	async clear(): Promise<void> {
		await this.getUserDocumentRef().set({ items: [] }, { merge: true });
	}

}
